@if (maintenance) {
  <div class="maintenance-container">
    <div class="maintenance-message-container">
      <div class="maintenance-title">
        {{ 'maintenance.title' | translate }}
      </div>
      <div class="maintenance-message">
        {{ 'maintenance.message' | translate }}
      </div>
    </div>
  </div>
}
@if (!maintenance) {
  <div id="global" class="global-container">
    @if (isSidebarVisible()) {
      <div>
        <div
          class="app-left-navigation"
          (mouseover)="onMouseover()"
          (mouseout)="onMouseout()"
          [class.extended]="fullSidebar"
          [fullSidebar]="fullSidebar"
          (panelToggle)="onPanelToggle($event)"
          (autoCollapseChange)="onAutoCollapseChange($event)"
        ></div>
      </div>
    }
    <main [ngClass]="mainClasses">
      @if (!loadingModel.isLoading) {
        <router-outlet></router-outlet>
      } @else {
        <span class="ui-loading" [model]="loadingModel"></span>
      }
    </main>
    @if (displayNotification$ | async) {
      <div id="alert-container" [ngClass]="(displayNotification$ | async) ? 'show-alert' : 'alert-hidden'">
        <app-alert></app-alert>
      </div>
    }
    @if (displayNotification$ | async) {
      <div id="alert-overlay"></div>
    }
    @if (isDemoMode) {
      <div class="demo-progress-ring" [style.--p]="demoServiceProgress$ | async"></div>
    }
  </div>
}

<app-feature-toggle-panel></app-feature-toggle-panel>

<!-- Global loader for long navigation (e.g. with resolvers) -->
